import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

const ApiTest = () => {
  const [testResult, setTestResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost';
  
  const testApi = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Test the API endpoint
      const response = await axios.get(`${API_URL}/api/test.php`);
      setTestResult(response.data);
    } catch (err) {
      console.error('API Test Error:', err);
      setError(err.message || 'Failed to connect to API');
    } finally {
      setLoading(false);
    }
  };
  
  const testLogin = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Test the login endpoint
      const response = await axios.post(`${API_URL}/api/auth/login.php`, {
        email: 'test@example.com',
        password: 'password123'
      });
      setTestResult(response.data);
    } catch (err) {
      console.error('Login Test Error:', err);
      if (err.response) {
        setTestResult({
          error: true,
          status: err.response.status,
          data: err.response.data
        });
      } else {
        setError(err.message || 'Failed to connect to login API');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container className="py-5">
      <Card className="shadow">
        <Card.Header className="bg-primary text-white">
          <h2>API Connection Test</h2>
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          
          <div className="mb-4">
            <Button 
              variant="primary" 
              onClick={testApi}
              disabled={loading}
              className="me-2"
            >
              {loading ? 'Testing...' : 'Test API Connection'}
            </Button>
            
            <Button 
              variant="secondary" 
              onClick={testLogin}
              disabled={loading}
            >
              {loading ? 'Testing...' : 'Test Login Endpoint'}
            </Button>
          </div>
          
          {testResult && (
            <div className="mt-4">
              <h4>Test Result:</h4>
              <pre className="bg-light p-3 border rounded">
                {JSON.stringify(testResult, null, 2)}
              </pre>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ApiTest;
